var exports = {
  "kL": "MessageUploadProgress.module__container___VzQxMT",
  "zc": "MessageUploadProgress.module__iconContainer___VzQxMT",
  "Qs": "MessageUploadProgress.module__content___VzQxMT",
  "Md": "MessageUploadProgress.module__fileName___VzQxMT",
  "Ov": "MessageUploadProgress.module__fileSize___VzQxMT",
  "L$": "MessageUploadProgress.module__progressContainer___VzQxMT",
  "Ik": "MessageUploadProgress.module__progressBarIndeterminate___VzQxMT",
  "U6": "MessageUploadProgress.module__pulse___VzQxMT",
  "hr": "MessageUploadProgress.module__progressBar___VzQxMT",
  "E$": "MessageUploadProgress.module__progressBarNormal___VzQxMT",
  "cs": "MessageUploadProgress.module__progressBarFailed___VzQxMT",
  "x7": "MessageUploadProgress.module__cancelButton___VzQxMT",
};

module.exports = exports;
